import React from 'react'
import './Contact.css'
import Section from '../section/Section'
import { Bounce } from 'react-reveal'
import ContactForm from '../contactForm/ContactForm'
import linkedin from '../../images/social/linkedin.png'
import github from '../../images/social/github.png'
import instagram from '../../images/social/icons-instagram.svg'

const Contact = () => {
  return (
    <Section title="Contact">
      <ContactForm />
      <Bounce cascade>
        <div className="links">
          <a
            href="https://github.com/crislemen"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={github} alt="Github Logo" width="40px" />
          </a>
          <a
            href="https://www.linkedin.com/in/cristian-le%C3%B3n-m%C3%A9ndez-43a5221a3/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} alt="Linkedin Logo" width="40px" />
          </a>

          <a
            href="https://www.instagram.com/crislemen/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className='StyleIntagram' src={instagram} alt="Instagram Logo" width="60px" />
          </a>
        </div>
      </Bounce>
    </Section>
  )
}

export default Contact
